export default "__VITE_ASSET__lVEu07m6__"